import React, { Component } from "react";
import Helper from "../../utilities/Helper";
import { withIntl } from "../../../common/lang";

class InsuranceProvider extends Component {
  componentDidUpdate = (prv) => {
    if (prv.insuranceProvider !== this.props.insuranceProvider) {
      this.props.setSelected(
        "insuranceProvider",
        this.checkInsuranceProvider(this.props.insuranceProvider)
      );
    }
  };

  handleInsuranceProviderInputChange = (event) => {
    this.props.handleOnChange(event);
  };

  insuranceProviderHelper = () => {
    const { formatMessage } = this.props.intl;
    if (this.checkInsuranceProvider(this.props.insuranceProvider)) {
      return (
        <Helper text={formatMessage({ id: "form.insuranceProvider.helper" })} />
      );
    }
  };

  checkInsuranceProvider = (insuranceProvider) => {
    if (insuranceProvider === "medicaid") {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="col-12 element-group">
        <div className="row">
          <div className="col-12">
            <div className="search-label">
              {formatMessage({ id: "form.insuranceProvider" })}
            </div>
          </div>
          <div className="col-12">
            <select
              className="form-control search-select-lg"
              name="insuranceProvider"
              onChange={this.handleInsuranceProviderInputChange}
              value={this.props.insuranceProvider}
            >
              <option value="">
                {formatMessage({ id: "ui.label.select" })}
              </option>
              <option value="non-medicaid">
                {formatMessage({ id: "form.insuranceProvider.nonMedicaid" })}
              </option>
              <option value="medicaid">
                {formatMessage({ id: "form.insuranceProvider.medicaid" })}
              </option>
              <option value="none">
                {formatMessage({ id: "form.insuranceProvider.none" })}
              </option>
            </select>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="helper-text">{this.insuranceProviderHelper()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default withIntl(InsuranceProvider);
